// extracted by mini-css-extract-plugin
export default {"button-box":"Review_button-box__-GwF5","Banner":"Review_Banner__PKNU3"};